/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { ValuesOf } from '@tmapy/beetlejuice-utils';

/**
 * ```yaml
 * type: string
 * description: >-
 *   * `OTHER` - Other
 *
 *   * `UPDATE_DATA` - Update data
 *
 *   * `REFERENCE_DATA` - Reference data
 *
 *   * `UPDATE_DATA_RANGE` - Update data range
 *
 *   * `DERIVED_DATA_RANGE` - Derived data range
 *
 *   * `METADATA` - Metadata
 *
 *   * `ROZSAH_EDITACE` - Rozsah editace
 *
 *   * `SYNCHRONIZACNI_DATA_SOUSEDNIHO_KRAJE` - Synchronizační data sousedního
 *   kraje
 *
 *   * `ZAPRACOVANA_DATA_PRESHRANICNI_EDITACE` - Zapracovaná data přeshraniční
 *   editace
 *
 *   * `DVOJICE_IDENTIFIKATORU` - Dvojice identifikátorů
 * ```
 */
export const AttachmentTypeEnum = {
  OTHER: 'OTHER',
  UPDATE_DATA: 'UPDATE_DATA',
  REFERENCE_DATA: 'REFERENCE_DATA',
  UPDATE_DATA_RANGE: 'UPDATE_DATA_RANGE',
  DERIVED_DATA_RANGE: 'DERIVED_DATA_RANGE',
  METADATA: 'METADATA',
  ROZSAH_EDITACE: 'ROZSAH_EDITACE',
  SYNCHRONIZACNI_DATA_SOUSEDNIHO_KRAJE: 'SYNCHRONIZACNI_DATA_SOUSEDNIHO_KRAJE',
  ZAPRACOVANA_DATA_PRESHRANICNI_EDITACE: 'ZAPRACOVANA_DATA_PRESHRANICNI_EDITACE',
  DVOJICE_IDENTIFIKATORU: 'DVOJICE_IDENTIFIKATORU',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type AttachmentTypeEnum = ValuesOf<typeof AttachmentTypeEnum>;

export type AttachmentTypeEnumRequest = AttachmentTypeEnum;
export type AttachmentTypeEnumResponse = AttachmentTypeEnum;
